import { z } from "zod";

import { CATEGORIES, TECHNICAL_ISSUE_TYPES } from "@/constants/contactForm";
import { requiresAudioReviewConsent } from "@/utils/contact/requiresAudioReviewConsent";

export type {
  ContactCategory,
  TechnicalIssueType,
} from "@/constants/contactForm";
export { CATEGORIES, TECHNICAL_ISSUE_TYPES } from "@/constants/contactForm";

export const contactFormSchema = z
  .object({
    name: z.string().min(1, "Name is required"),
    email: z.string().email("Invalid email address"),
    category: z.enum(CATEGORIES, {
      errorMap: () => ({ message: "Please select a valid category" }),
    }),
    technicalIssueType: z
      .enum(TECHNICAL_ISSUE_TYPES, {
        errorMap: () => ({
          message: "Please select a valid technical issue type",
        }),
      })
      .optional(),
    consentToAudioReview: z.boolean().optional(),
    message: z.string().min(30, "Message must be at least 30 characters long"),
  })
  .superRefine((data, ctx) => {
    if (
      data.category === "technical" &&
      data.technicalIssueType === undefined
    ) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message:
          "Technical issue type is required for technical support inquiries",
        path: ["technicalIssueType"],
      });
    }

    const shouldRequireConsent = requiresAudioReviewConsent({
      category: data.category,
      technicalIssueType: data.technicalIssueType,
    });

    if (
      shouldRequireConsent &&
      (data.consentToAudioReview === undefined || !data.consentToAudioReview)
    ) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message:
          "This issue type requires audio review to be investigated. Please enable audio review to submit your request, or select a different ticket category.",
        path: ["consentToAudioReview"],
      });
    }
  });
